// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__jTkuR","filesListContainer":"PosDisputesFiles_filesListContainer__1O2zL","filesButton":"PosDisputesFiles_filesButton__3YEv2"};